export const parse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
